import React, {useState, useContext, createContext} from 'react'



const IndicatorsValuesContext = createContext();

const IndicatorBlock = ({data, showAll}) => {
  const VALUES = useContext(IndicatorsValuesContext);



  let indId = data.id
  let value = VALUES[indId]

  if(value === undefined && !showAll) return null

  let name = data.title
  let desc = data.description

  let style = {}
  if(value !== undefined) {
    // value = Math.floor(value * 100) / 100
  } else {
    style = {backgroundColor: "#ffb0b0"}
    value = "undefined"

  }

  return (
    <div className="indicator">
      <div>
        <span className="indicator-id" style={style}>{indId}</span>
        <span className="indicator-name">{name} : </span>
        <span className="indicator-value">{value}</span>
      </div>
      <div className="indicator-desc">{desc}</div>
    </div>)
}


function keep(i, search) {

  if(!i.id) return false
  return i.id.toLowerCase().indexOf(search.toLowerCase()) > -1
}

const Indicators = ({data, values}) => {

  let [showAll, setShowAll] = useState(true)
  const [search, setSearch] = useState("")

  return (
    <IndicatorsValuesContext.Provider value={values}>
      <div className="indicators">
        <label >
          <input type="checkbox" value={showAll} onChange={(e)=>{setShowAll(e.target.checked)}}  />
          {showAll ? "Hide empty indicators" : "Show all indicators"}

          <br/>

          <input type="text" placeholder="Filter par id" value={search} onChange={e => setSearch(e.target.value)}/>

        </label>
        {data
        .filter(i => keep(i, search) )
        .map(i => <IndicatorBlock data={i} showAll={showAll} key={i.id} />)}
      </div>
    </IndicatorsValuesContext.Provider>
  )
}

export default Indicators